<!-- Loading bar -->
<!-- <fuse-loading-bar></fuse-loading-bar> -->

<ng-container>
    <!-- custom-bar-bg -->
    <!-- Navigation -->
    <fuse-vertical-navigation
        class="bg-white border border-gray-200 border-t-0 border-l-0 border-r-1 border-b-0 print:hidden main_sidebar"
        [appearance]="navigationAppearance" [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'"
        [navigation]="navigation" [opened]="!isScreenSmall">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center justify-center h-14">
                <a routerLink="/warmup">
                    <img *ngIf="settingsData && settingsData?.imagePath && settingsData?.logo"
                        class="w-8 cursor-pointer" [src]="settingsData?.imagePath + settingsData?.logo"
                        [alt]="settingsData?.site_name">
                </a>

                <ngx-skeleton-loader *ngIf="!settingsData || !settingsData?.imagePath" class="lh-1" [theme]="{
                      width: '32px',
                      height: '32px',
                      'margin': '13px 13px 0',
                      'padding':'13px'
                    }"></ngx-skeleton-loader>
            </div>
        </ng-container>


        <ng-container fuseVerticalNavigationFooter>
            <div class="fuse-vertical-navigation-item-wrapper cursor-pointer hover:bg-primary-300 rounded"
                *ngIf="profileData">
                <div class="fuse-vertical-navigation-item flex items-center px-5 py-2.5"
                    [tooltip]="'BILLING_PAGE.SUBSCRIPTION' | translate" routerLink="/manage/subscription"
                    [class.fuse-vertical-navigation-item-active]="activeParam?.includes('subscription')">
                    <ng-container>
                        <mat-icon class="fuse-vertical-navigation-item-icon icon-size-6"
                            [svgIcon]="'heroicons_outline:credit-card'"></mat-icon>

                    </ng-container>
                    <div class="fuse-vertical-navigation-item-title-wrapper">
                        <div class="fuse-vertical-navigation-item-title footer_item">
                            <span [ngClass]="">
                                {{'BILLING_PAGE.SUBSCRIPTION' | translate}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <mat-menu yPosition="above" xPosition="after" #aboveMenu="matMenu">
                <button mat-menu-item routerLink="/manage/profile">
                    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                    <span>Profile</span>
                </button>
                <mat-divider class="my-2"></mat-divider>
                <button mat-menu-item (click)="signOut()">
                    <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
                    <span>Sign out</span>
                </button>
            </mat-menu>

            <div class="fuse-vertical-navigation-item-wrapper cursor-pointer hover:bg-transparent"
                [matMenuTriggerFor]="aboveMenu" *ngIf="profileData">
                <div class="fuse-vertical-navigation-item flex  pr-5 py-[10px]"
                    [ngClass]="{'pl-[19px]': !profileData?.imageUrl, 'pl-[14px]' : profileData && profileData?.imageUrl}">
                    <ng-container>
                        <img *ngIf="!profileData?.image"
                            class="w-9 h-9 mr-3 min-w-9 min-h-9 max-w-9 rounded-full object-cover object-top"
                            [src]="'noimage.jpg' | imagePath" />
                        <img class="w-9 h-9 mr-3 min-w-9 min-h-9 max-w-9 rounded-full object-cover object-top"
                            *ngIf="profileData && profileData?.image" [src]="profileData?.imageUrl"
                            [alt]="profileData?.name">
                    </ng-container>
                    <div class="fuse-vertical-navigation-item-title-wrapper" *ngIf="profileData">
                        <div class="fuse-vertical-navigation-item-title font-semibold text-primary-500">
                            <span>
                                {{profileData?.name}}
                            </span>
                        </div>
                        <ng-container>
                            <div class="fuse-vertical-navigation-item-subtitle text-primary-300">
                                <span>
                                    {{profileData?.email}}
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>


    </fuse-vertical-navigation>

    <!-- Item template -->
    <ng-template #itemTemplate>

        <!-- Icon -->
        <ng-container *ngIf="item.icon">
            <mat-icon class="fuse-vertical-navigation-item-icon" [ngClass]="item.classes?.icon"
                [svgIcon]="item.icon"></mat-icon>
        </ng-container>
        <ng-container *ngIf="!item.icon && item.classes?.icon">
            <mat-icon class="fuse-vertical-navigation-item-icon" [ngClass]="item.classes?.icon"></mat-icon>
        </ng-container>

        <!-- Title & Subtitle -->
        <div class="fuse-vertical-navigation-item-title-wrapper">
            <div class="fuse-vertical-navigation-item-title">
                <span [ngClass]="item.classes?.title">
                    {{item.title}}
                </span>
            </div>
            <ng-container *ngIf="item.subtitle">
                <div class="fuse-vertical-navigation-item-subtitle">
                    <span [ngClass]="item.classes?.subtitle">
                        {{item.subtitle}}
                    </span>
                </div>
            </ng-container>
        </div>

        <!-- Badge -->
        <ng-container *ngIf="item.badge">
            <div class="fuse-vertical-navigation-item-badge">
                <div class="fuse-vertical-navigation-item-badge-content" [ngClass]="item.badge.classes">
                    {{item.badge.title}}
                </div>
            </div>
        </ng-container>

    </ng-template>

    <!-- Wrapper -->
    <div class="flex flex-col flex-auto w-full min-w-0">

        <!-- Header -->
        <div
            class="relative flex flex-0 items-center w-full h-14 px-5 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
            <div class="flex items-center pr-2 ml-0">
                <!-- Navigation toggle button -->
                <button class="md:hidden inline-flex" mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                </button>
                <!-- Navigation appearance toggle button -->
                <button class="hidden" mat-icon-button (click)="toggleNavigationAppearance()">
                    <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
                </button>
                <a [href]="partnerachUrl + '/dashboard'" target="_blank"
                    class="base_btn text-primary bg-primary/20 rounded text-md font-medium leading-[14px] min-h-[34px] max-h-[34px] ml-auto group no_shadow">
                    <span class="whitespace-nowrap">{{"DASHBOARD.GO_TO_PARTNER_REACH" | translate}}</span>
                </a>
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto space-x-0.5 sm:space-x-2">
                <div class="bg-red-100 border-l-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border-red-500 text-red-700 px-4 py-2.5"
                    role="alert" *ngIf="isConnectionAlert && connectionStatus == 'offline'">
                    <p class="font-bold">Connection lost! You are not connected to internet.</p>
                </div>
                <div class="bg-yellow-100 border-l-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border-yellow-500 text-yellow-700 px-4 py-2.5"
                    role="alert" *ngIf="isConnectionAlert && connectionStatus == 'connecting'">
                    <p class="font-bold">Please wait connection is being restored.</p>
                </div>
                <div class="bg-green-100 border-l-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border-green-500 text-green-700 px-4 py-2.5"
                    role="alert" *ngIf="isConnectionAlert && connectionStatus == 'online'">
                    <p class="font-bold">You are now back online.</p>
                </div>

                <languages></languages>
                <button
                    *ngIf="settingsData?.walkthrough_setup == 0 && settingsData?.is_super_admin == 1 && !settingsData?.is_direct_shopify"
                    class="base_btn text-primary bg-primary/20 rounded  text-md font-medium leading-[14px] min-h-[34px] max-h-[34px] ml-auto group no_shadow">
                    <mat-icon [svgIcon]="'heroicons_outline:light-bulb'" class="text-primary"></mat-icon>
                    <span class="ml-2">Complete Onboarding</span>
                </button>

                <button
                    *ngIf=" settingsData?.is_super_admin == 1 && completedStepsValue != 100 && settingsData?.is_direct_shopify && (!settingsData?.onboarding_steps || (settingsData?.onboarding_steps && !settingsData?.onboarding_steps?.hide_shopify_onboarding))"
                    class="base_btn text-primary bg-primary/20 rounded  text-md font-medium leading-[14px] min-h-[34px] max-h-[34px] ml-auto group no_shadow"
                    (click)="isStepsVisible = !isStepsVisible">
                    <mat-icon [svgIcon]="'heroicons_outline:light-bulb'" class="text-primary"></mat-icon>
                    <span class="ml-2">{{!isStepsVisible ? 'Complete Setup' : 'Hide Setup Steps'}}</span>
                </button>
                <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                <!-- <user></user> -->
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-col flex-auto">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>

    </div>
</ng-container>